export default __webpack_public_path__ + "static/media/environment-details.175396e3.png";